(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bf-budget-slider"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-bf-deals]').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const track=root.querySelector('[data-deals-track]');
  const dots=[...root.querySelectorAll('[data-deal-dot]')];
  const pause=root.querySelector('[data-deal-pause]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused=reduced.matches,index=0;
  function updatePause(){pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?'▶':'Ⅱ'}
  function go(n){index=(n+dots.length)%dots.length;track.scrollTo({left:index*track.clientWidth,behavior:reduced.matches?'instant':'smooth'})}
  root.querySelector('[data-deal-prev]').addEventListener('click',()=>go(index-1));
  root.querySelector('[data-deal-next]').addEventListener('click',()=>go(index+1));
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i)));
  pause.addEventListener('click',()=>{paused=!paused;updatePause()});
  track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1))}});
  track.addEventListener('scroll',()=>{index=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)))},{passive:true});
  reduced.addEventListener('change',()=>{if(reduced.matches){paused=true;updatePause()}});
  updatePause();
  const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return}const box=root.getBoundingClientRect();if(!paused&&!document.hidden&&!root.matches(':hover')&&!root.contains(document.activeElement)&&box.top<innerHeight&&box.bottom>0)go(index+1)},6000);
});
  } catch(e) { console.error(e); }
})();

})();
